export interface ISeason {
  year: string
  slug: string
  remoteSlug: string
  id: number
}

// First season in array is exported as the current one
const seasonsInOrder: ISeason[] = [
  { year: '2026/27', slug: 'latest', remoteSlug: '2026-27', id: 28 },
  { year: '2025/26', slug: '2025-26', remoteSlug: '2025-26', id: 27 },
]

const getRemoteSeasonSlug = (seasonSlug: string): string =>
  seasonsInOrder.find((season) => season.slug === seasonSlug).remoteSlug

module.exports = {
  seasons: seasonsInOrder,
  latestSeason: seasonsInOrder[0],
  previousSeason: seasonsInOrder[1],
  getRemoteSeasonSlug,
}
